export default __webpack_public_path__ + "static/media/arrow-up-blue.357fc9f1.svg";